<template>
  <div class="flex flex-col lg:flex-row w-full h-full mx-auto py-4 lg:p-6">
    <div class="bg-white shadow-lg rounded-lg w-12/12 lg:w-2/6 mx-4 py-4 overflow-hidden mb-4 lg:mb-0">
      
      <div class="h-full overflow-auto px-4">

        <div class="flex items-center gap-1 justify-end pb-4 sticky top-0 bg-white relative z-10">
          <h1 class="flex items-center gap-1 font-bold text-gray-900 px-2 py-2 leading-tight tracking-wider">
            Lista de Usuarios
            <span class="rounded-full px-4 py-1 bg-gray-200">
              {{ filteredUserList.length }}
            </span>
          </h1>
          <div class="flex-1"></div>
          <button
            class="border p-1 rounded border-gray-700"
            @click="changeFormOrder"
            aria-label="Ordenar usuarios ascentente o descendente"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 fill-current"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path d="M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z"/>
              <path d="M0 0h24v24H0z" fill="none" />
            </svg>
          </button>
        </div>

        <input
          type="text"
          v-model="search"
          placeholder="Búsqueda de usuarios"
          class="w-full appearance-none border rounded py-2 px-3 mb-3 text-gray-900 bg-gray-200 focus:outline-none focus:bg-white"
        />

        <div class="w-full">
          <div class="w-full relative">
            <select
              class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 mb-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
              name="status"
              id="status"
              v-model="categoryFilter"
            >
              <option selected value="-1">Todos</option>
              <option v-for="category in userCategories" :key="category.id" :value="category.id">
                {{ category.name_category }}
              </option>
            </select>
            <div
              class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
            >
              <svg
                class="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                />
              </svg>
            </div>
          </div>
        </div>

        <div class="w-full flex gap-1 my-1">
          <btn-action
            v-on:click="
              (statusFilterUser = 'all'), filteredUserList, updateSelectRegister()
            "
            class="w-1/3 hover:text-white border rounded p-2 font-semibold"
            v-bind:class="[
              statusFilterUser === 'all'
                ? 'border-transparent bg-selected'
                : 'bg-transparent'
            ]"
            :colorT="color_terciario"
          >
            Todos
          </btn-action>
          <btn-action
            v-on:click="
              (statusFilterUser = 'active'),
                filteredUserList,
                updateSelectRegister()
            "
            class="w-1/3 hover:text-white border rounded p-2 font-semibold"
            v-bind:class="[
              statusFilterUser === 'active'
                ? 'border-transparent bg-selected'
                : 'bg-transparent'
            ]"
            :colorT="color_terciario"
          >
            Activos
          </btn-action>
          <btn-action
            v-on:click="
              (statusFilterUser = 'inactive'),
                filteredUserList,
                updateSelectRegister()
            "
            class="w-1/3 hover:text-white border rounded p-2 font-semibold"
            v-bind:class="[
              statusFilterUser === 'inactive'
                ? 'border-transparent bg-selected'
                : 'bg-transparent'
            ]"
            :colorT="color_terciario"
          >
            Inactivos
          </btn-action>
        </div>

      
        <div-selected-styled
          v-for="currentUser in filteredUserList"
          v-on:click="getUser(currentUser)"
          :key="currentUser.id"
          class="group flex items-center cursor-pointer my-1 hover:bg-gray-300 py-2 px-5 text-left"
          :class="{ 'bg-selected': currentUser.id === user.id }"
          :colorT="color_terciario"
        >
          <img
            :src="currentUser.profile_image"
            @error="loadDefaultImg"
            class="object-cover h-12 w-12 rounded-full"
            v-bind:class="[
              currentUser.inactive
                ? 'border-solid border-2 border-danger-color'
                : 'border-solid border-2 border-primary-color'
            ]"
          />
          <div class="flex flex-col ml-2">
            <span
              :class="[
                currentUser.id === user.id ? 'text-gray-100' : 'text-gray-900'
              ]"
              class="group-hover:text-gray-900"
              >{{ currentUser.name }} {{ currentUser.last_name }}</span
            >
            <span
              :class="[
                currentUser.id === user.id ? 'text-gray-300' : 'text-gray-700'
              ]"
              class="text-sm group-hover:text-gray-700"
              >{{ currentUser.email }}</span
            >
            <span
              :class="[
                currentUser.id === user.id ? 'text-gray-300' : 'text-gray-700'
              ]"
              class="text-sm group-hover:text-gray-700"
              >{{ currentUser.name_category }}</span
            >
          </div>
        </div-selected-styled>
      </div>
    </div>
    <div
      class="flex flex-wrap bg-white shadow-lg rounded-lg w-12/12 lg:w-4/6 mx-4 pt-8 pb-6 overflow-hidden"
    >
      <div class="w-full px-4 py-2 h-full overflow-auto">
        <div class="w-full flex flex-wrap items-center">
          <div class="flex-1 text-right" v-if="user">
            <btn-action
              v-on:click="updateDataModal(user)"
              class="bg-transparent font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border hover:border-transparent rounded"
              :colorT="color_terciario"
            >
              Editar
            </btn-action>
            <btn-action
              v-if="user.inactive"
              @click="showingConfirmActive = true"
              class="bg-transparent font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border hover:border-transparent rounded"
              :colorT="color_terciario"
            >
              Activar
            </btn-action>
            <button
              v-if="!user.inactive"
              @click="showingConfirmInactive = true"
              class="bg-transparent hover:bg-red-500 text-danger-color font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-danger-color hover:border-transparent rounded"
            >
              Desactivar
            </button>
            <button
              class="bg-transparent hover:bg-red-500 text-danger-color font-semibold hover:text-white py-2 px-4 mx-1 border border-danger-color hover:border-transparent rounded"
              @click="showingDeleteConfirm = true"
            >
              Eliminar
            </button>
          </div>
        </div>
        <div
          class="w-full flex flex-col lg:flex-row flex-wrap items-center"
          v-if="user"
        >
          <div
            class="w-full lg:w-1/3 flex items-center justify-start lg:justify-center pt-2 lg:pt-0"
          >
            <img
              :src="user.profile_image"
              class="object-cover h-12 lg:h-64 w-12 lg:w-64 rounded-full"
              v-bind:class="[
                user.inactive
                  ? 'border-solid border-4 border-danger-color'
                  : 'border-solid border-4 border-primary-color'
              ]"
            />
          </div>
          <div class="w-full lg:w-2/3">
            <br />
            <div style="text-align: left">
              <span class="font-bold text-gray-900">Información Personal</span>
            </div>
            <div class="w-full">
              <div class="flex items-center pt-2 text-sm">
                <span class="font-bold text-gray-900">Nombre:</span>
                <span class="ml-2 text-gray-700"
                  >{{ user.name }} {{ user.last_name }}</span
                >
              </div>
              <div class="flex items-center pt-2 text-sm">
                <span class="font-bold text-gray-900">Correo:</span>
                <span class="ml-2 text-gray-700">{{ user.email }}</span>
              </div>
            </div>
            <br />
            <div style="text-align: left">
              <div class="font-bold text-gray-900">Información Extra</div>
            </div>
            <!--             <div class="flex items-center pt-2 text-sm">
              <span class="font-bold text-gray-900">¿Fue esta persona ayudada?:</span>
              <span class="ml-2 text-gray-700">{{user.help}}</span>
            </div> -->
            <div class="flex items-center pt-2 text-sm">
              <span class="font-bold">Rol:</span>
              <span class="px-2">{{ user.name_category }}</span>
            </div>
            <div class="flex items-center pt-2 text-sm">
              <span class="font-bold">Edad:</span>
              <span class="px-2">{{ user.edad }}</span>
            </div>
            <div class="flex items-center pt-2 text-sm">
              <span class="font-bold">Sexo:</span>
              <span class="px-2">{{ user.sexo }}</span>
            </div>
            <div class="flex items-center pt-2 text-sm">
              <span class="font-bold">Nivel Escolar:</span>
              <span class="px-2">{{ user.nivel_estudios }}</span>
            </div>
            <div class="flex items-center pt-2 text-sm">
              <span class="font-bold">Idioma:</span>
              <span class="px-2">{{ user.idioma }}</span>
            </div>
            <div class="flex items-center pt-2 text-sm">
              <span class="font-bold">Ocupación:</span>
              <span class="px-2">{{ user.ocupacion }}</span>
            </div>
          </div>

          <div class="w-full mx-auto">
            <br /><br />
            <span class="font-bold text-gray-900 text-lg">Bitácora</span>
            <div class="bg-white shadow-md rounded my-6">
              <input
                type="date"
                v-model="searchByday"
                class="w-1/2 lg:w-1/3 appearance-none border rounded py-2 px-3 mb-3 text-gray-900 bg-gray-200 focus:outline-none focus:bg-white"
              />
              <btn-action
                class="bg-transparent text-cdmx-blue-dark text-sm font-semibold hover:text-white py-1 px-2 mx-1 mb-3 border hover:border-transparent rounded"
                @click="clearSelectedDate()"
                :colorT="color_terciario"
              >
                Limpiar
              </btn-action>
              <br />
              <div>
                <input
                  class="w-12/12 lg:w-4/6 px-2 border-2 border-gray-500 rounded-md mb-2"
                  type="text"
                  placeholder="Filtrar por módulo, accción u observación"
                  v-model="tableFilter"
                />
                <!-- <input style="width:500px;padding-left:10px; border: 3px solid #ccc;" type="text" placeholder="Filtrar por módulo, accción u observación" v-model="tableFilter" /> -->
              </div>

              <div style="max-height: 600px; overflow: auto">
                <table class="text-left w-full border-collapse">
                  <thead>
                    <tr>
                      <th
                        class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                      >
                        Módulo
                      </th>
                      <th
                        class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                      >
                        Acción
                      </th>
                      <th
                        class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                      >
                        Observación
                      </th>
                      <th
                        class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300 flex items-center"
                      >
                        Fecha
                        <button
                          class="border-2 rounded border-gray-700 ml-2"
                          @click="changeFormOrderBinnacles"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-4 w-4 fill-current"
                            viewBox="0 0 24 24"
                          >
                            <path
                              d="M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z"
                            />
                            <path d="M0 0h24v24H0z" fill="none" />
                          </svg>
                        </button>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="type in filteredBinnacles" class="hover:bg-gray-200" :key="type.id">
                      <td class="py-4 px-6 border-b border-gray-300">
                        {{ type.module }}
                      </td>
                      <td class="py-4 px-6 border-b border-gray-300">
                        {{ type.action }}
                      </td>
                      <td
                        v-html="type.observation"
                        class="py-4 px-6 border-b border-gray-300"
                        style="white-space: pre-line"
                      ></td>
                      <td class="py-4 px-6 border-b border-gray-300">
                        {{ type.date | moment("DD/MM/YYYY hh:mm a") }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <user-modal
      :showing="showUserModal"
      @updateUser="updateUser"
      @close="showUserModal = false"
      :colorP="color_principal"
      :colorS="color_secundario"
      :colorT="color_terciario"
    ></user-modal>

    <alert-dialog :showing="showingConfirmActive">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">¿Desea activar este usuario?</div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-secondary-color border-4 font-bold tracking-wider bg-white hover:bg-secondary-color"
          @click="updateActivity()"
        >
          Activar
        </button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-500"
          @click="showingConfirmActive = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingConfirmInactive">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          ¿Desea desactivar este usuario?
        </div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-500"
          @click="updateActivity()"
        >
          Desactivar
        </button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-500"
          @click="showingConfirmInactive = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingSuccessDesactivation">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Desactivado exitosamente</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccessDesactivation = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>
    <alert-dialog :showing="showingSuccessActivation">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Activado exitosamente</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccessActivation = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingDeleteConfirm">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          ¿Realmente desea eliminar este usuario? Esta acción no se puede
          deshacer
        </div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
          @click="realDeleteUser()"
        >
          Eliminar
        </button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingDeleteConfirm = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingSuccessDelete">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          Usuario eliminado exitosamente
        </div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-primary-color"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccessDelete = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingProjectNotEmpty">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          El Usuario no se puede eliminar, tiene proyectos y/o fichas asociadas
        </div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-danger-color"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingProjectNotEmpty = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>
  </div>
</template>

<script>
import userModal from "./UserModal";
import AlertDialog from "./AlertDialog";
import EventBus from "../event-bus";
import moment from "moment";
import axios from "axios";
import XLSX from "xlsx";

import { styled } from "@egoist/vue-emotion";

const BtnAction = styled("button")`
  color: ${props => props.colorT};
  border-color: ${props => props.colorT};
  &.bg-selected {
    background-color: ${props => props.colorT};
    color: #fff;
  }
  &:hover {
    background-color: ${props => props.colorT};
  }
`;

const DivSelectedStyled = styled("div")`
  &.bg-selected {
    background-color: ${props => props.colorT};
  }
  &:hover {
    background-color: #d1d5db;
  }
`;

export default {
  name: "userList",
  data() {
    return {
      chatAlert: null,
      chartList: null,
      showChatModal: false,
      showingConfirmActive: false,
      showingConfirmInactive: false,
      showingSuccessDesactivation: false,
      showingSuccessActivation: false,
      showingDeleteConfirm: false,
      showingSuccessDelete: false,
      showingProjectNotEmpty: false,
      json_fields: {
        Nombre: "name",
        Apellido: "last_name",
        Categoria: "name_category",
        Correo: "email",
        Edad: "age",
        Sexo: "sex",
        Telefono: "phone_number",
        Dirección: "address",
        "Url de perfil": "profile_image",
        ID: "auth_id",
        Dispositivo: "device_id"
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      showUserModal: false,
      selectedIndex: 0,
      userList: [],
      user: null,
      newGuestUser: false,
      search: "",
      searchByday: "",
      statusFilterUser: "all",
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      },
      alerts: [],
      binnacles: [],
      alertFilter: "assigned",
      categoryFilter: "-1",
      userCategories: [],
      formOrder: "upward",
      formOrderBinnacle: "upward",
      tableFilter: "",
      color_principal: "",
      color_secundario: "",
      color_terciario: ""
    };
  },
  components: {
    userModal,
    AlertDialog,
    BtnAction,
    DivSelectedStyled
  },
  created() {
    let that = this;
  },
  mounted() {
    EventBus.$emit("updateNotification", {});
    this.getUserList();
    this.fetchUserCategories();
  },
  methods: {
    updateSelectRegister() {
      if (this.filteredUserList.length > 0) {
        this.getUser(this.filteredUserList[0]);
      }
    },

    getUserList: function () {
      this.$root.$emit("showLoading");
      axios
        .get("apidev/users/", this.config)
        .then(response => {
          this.userList = response.data;
          this.userList.forEach(data => {
            if (data.profile_image != null && data.profile_image !== "") {
              data.profile_image = "apidev/" + data.profile_image;
              //data.profile_image =
              // "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png";
            } else {
              data.profile_image =
                "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png";
            }
          });

          if (this.filteredUserList.length > 0) {
            this.getUser(this.filteredUserList[0]);
          }

          this.$root.$emit("hideLoading");
        })
        .catch(error => {
          this.catchError(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    getUser: function (user) {
      this.user = user;
      // removed console log
      this.fetchUserBinnacles(this.user.id);
    },

    updateDataModal: function (user) {
      this.showUserModal = true;
      this.newGuestUser = false;
      EventBus.$emit("editModal", user);
    },

    fetchUserBinnacles: function (user_id) {
      this.axios
        .post(
          "/apidev/bitacoras/list/",
          {
            user_id: user_id
          },
          this.config
        )
        .then(response => {
          this.binnacles = response.data.binnacles;
          // removed console log
        })
        .catch(error => {
          // removed console log
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    newDataModal: function () {
      this.showUserModal = true;
      this.newGuestUser = true;
    },

    updateUser: function (select_user) {
      this.userList.forEach(user => {
        if (user.id == select_user.id) {
          let updateUser = Object.assign({}, select_user);
          user.name = updateUser.name;
          user.last_name = updateUser.last_name;
          user.address = updateUser.address;
          user.phone_number = updateUser.phone_number;
          user.age = updateUser.age;
          user.sex = updateUser.sex;
          user.auth_id = updateUser.auth_id;
          user.category_id = updateUser.category_id;
          user.name_category = updateUser.name_category;
          user.profile_image = updateUser.profile_image;
        }
      });
    },

    updateActivity: function () {
      this.$root.$emit("showLoading");
      let nombre_usuario = this.user.name + " " + this.user.last_name;
      if (this.user.inactive) {
        // usuario inactivo, activar usuario
        this.axios
          .post(
            "apidev/users/inactive/rol",
            {
              inactive: "false",
              email: this.user.email,
              user_id: this.user.id
            },
            this.config
          )
          .then(response => {
            this.showingConfirmActive = false;

            //guarda bitácora
            let name = localStorage.getItem("name");

            //// removed console log
            this.axios
              .post(
                "/apidev/bitacoras/save/",
                {
                  module: "Usuarios",
                  action: "Activación de usuario",
                  observation:
                    name +
                    " activó al usuario " +
                    nombre_usuario +
                    "(" +
                    this.user.email +
                    ")",
                  email: localStorage.getItem("email"),
                  user_id: localStorage.getItem("user_id")
                },
                this.config
              )
              .then(response => {
                //// removed console log
              })
              .catch(error => {
                // removed console log
              });
            //FIN guarda bitácora

            this.$root.$emit("hideLoading");
            this.showingSuccessActivation = true;
            this.getUserList();
          })
          .catch(error => {
            this.catchError(error);
          });
      } else {
        // desactivar usuario
        this.axios
          .post(
            "apidev/users/inactive/rol",
            {
              inactive: "true",
              email: this.user.email,
              user_id: this.user.id
            },
            this.config
          )
          .then(response => {
            this.showingConfirmInactive = false;

            //guarda bitácora
            let name = localStorage.getItem("name");

            //// removed console log
            this.axios
              .post(
                "/apidev/bitacoras/save/",
                {
                  module: "Usuarios",
                  action: "Desctivación de usuario",
                  observation:
                    name +
                    " desactivó al usuario " +
                    nombre_usuario +
                    "(" +
                    this.user.email +
                    ")",
                  email: localStorage.getItem("email"),
                  user_id: localStorage.getItem("user_id")
                },
                this.config
              )
              .then(response => {
                //// removed console log
              })
              .catch(error => {
                // removed console log
              });
            //FIN guarda bitácora

            this.$root.$emit("hideLoading");
            this.showingSuccessDesactivation = true;
            this.getUserList();
          })
          .catch(error => {
            this.catchError(error);
          });
      }
    },
    fetchUserCategories() {
      this.axios
        .get("apidev/users/categories", this.config)
        .then(response => {
          this.userCategories = response.data.categories;
        })
        .catch(error => {
          this.catchError(error);
        });
    },
    loadDefaultImg(event) {
      event.target.src =
        "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png";
    },
    changeFormOrder() {
      if (this.formOrder === "upward") {
        this.formOrder = "downward";
      } else {
        this.formOrder = "upward";
      }
    },
    changeFormOrderBinnacles() {
      if (this.formOrderBinnacle === "upward") {
        this.formOrderBinnacle = "downward";
      } else {
        this.formOrderBinnacle = "upward";
      }
    },
    clearSelectedDate() {
      this.searchByday = "";
    },
    catchError(error) {
      if (error.response.status == 400 || error.response.status == 401) {
        if (
          error.response.data.name === "TokenExpiredError" ||
          error.response.data.name === "InvalidTokenError" ||
          error.response.data.name === "JsonWebTokenError"
        ) {
          this.$router.push({ path: "/login" });
        }
      }

      this.$root.$emit("hideLoading");
    },
    realDeleteUser() {
      this.$root.$emit("showLoading");
      this.axios
        .delete(
          "../apidev/users/deleteUser/" + this.user.id,
          {
            user_id: localStorage.getItem("user_id"),
            activo: "false"
          },
          this.config
        )
        .then(response => {
          if (response["data"]["status"] == "Usuario eliminado") {
            this.user = {};
            this.getUserList();
            this.search = "";
            this.showingDeleteConfirm = false;
            this.$root.$emit("hideLoading");
            this.showingSuccessDelete = true;
          }

          if (
            response["data"]["status"] ==
            "El usuario tiene proyectos y fichas asociadas"
          ) {
            this.showingDeleteConfirm = false;
            this.$root.$emit("hideLoading");
            this.showingProjectNotEmpty = true;
          }
        })
        .catch(error => {
          // removed console log
          this.showingDeleteConfirm = false;
          this.$root.$emit("hideLoading");
          this.showingError = true;
        });
    },
    fetchConfiguration() {
      this.axios
        .get("apidev/api/config/site")
        .then(response => {
          let conf = response.data.config;
          /* this.url_image = conf.url_image; */
          this.color_principal = conf.color_principal;
          this.color_secundario = conf.color_secundario;
          this.color_terciario = conf.color_terciario;
        })
        .catch(error => {
          // removed console log
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    }
  },

  computed: {
    filteredUserList: function () {
      return this.userList
        .filter(user => {
          let full_name = user.name + " " + user.last_name;
          switch (this.statusFilterUser) {
            case "all":
              return (
                (full_name.toLowerCase().includes(this.search.toLowerCase()) ||
                  user.name_category
                    .toLowerCase()
                    .includes(this.search.toLowerCase()) ||
                  user.email
                    .toLowerCase()
                    .includes(this.search.toLowerCase())) &&
                (this.categoryFilter === "-1" ||
                  user.category_id === this.categoryFilter)
              );
            case "active":
              return (
                (full_name.toLowerCase().includes(this.search.toLowerCase()) ||
                  user.name_category
                    .toLowerCase()
                    .includes(this.search.toLowerCase()) ||
                  user.email
                    .toLowerCase()
                    .includes(this.search.toLowerCase())) &&
                !user.inactive &&
                (this.categoryFilter === "-1" ||
                  user.category_id === this.categoryFilter)
              );
            case "inactive":
              return (
                (full_name.toLowerCase().includes(this.search.toLowerCase()) ||
                  user.name_category
                    .toLowerCase()
                    .includes(this.search.toLowerCase()) ||
                  user.email
                    .toLowerCase()
                    .includes(this.search.toLowerCase())) &&
                user.inactive &&
                (this.categoryFilter === "-1" ||
                  user.category_id === this.categoryFilter)
              );
            default:
              break;
          }
        })
        .sort((a, b) => {
          if (this.formOrder === "upward") {
            if (a.name != null && b.name != null) {
              if (a.name.toLowerCase() < b.name.toLowerCase()) {
                return -1;
              }
              if (a.name.toLowerCase() > b.name.toLowerCase()) {
                return 1;
              }
            }
            return 0;
          } else {
            if (a.name != null && b.name != null) {
              if (a.name.toLowerCase() > b.name.toLowerCase()) {
                return -1;
              }
              if (a.name.toLowerCase() < b.name.toLowerCase()) {
                return 1;
              }
            }
            return 0;
          }
        });
    },

    filteredBinnacles() {
      return this.binnacles
        .filter(binnacle => {
          let date = moment(binnacle.date).format("YYYY-MM-DD");

          if (this.tableFilter != "") {
            const module = binnacle.module.toString().toLowerCase();
            const action = binnacle.action.toLowerCase();
            const observation = binnacle.observation.toLowerCase();
            const searchTerm = this.tableFilter.toLowerCase();

            return (
              (module.includes(searchTerm) ||
                action.includes(searchTerm) ||
                observation.includes(searchTerm)) &&
              date.toLowerCase().includes(this.searchByday.toLowerCase())
            );
          } else {
            return date.toLowerCase().includes(this.searchByday.toLowerCase());
          }
        })
        .sort((a, b) => {
          if (this.formOrderBinnacle === "upward") {
            return new Date(a.date) - new Date(b.date);
          } else {
            return new Date(b.date) - new Date(a.date);
          }
        });
    },
    filteredAlerts() {
      return this.alerts.filter(alert => {
        let date = moment(alert.fecha_alerta).format("YYYY-MM-DD");

        switch (this.alertFilter) {
          // case "all":
          //   return date.toLowerCase().includes(this.searchByday.toLowerCase());
          case "attended":
            if (alert.status === "ATENDIDA") {
              if (
                this.searchByday === "" ||
                date.toLowerCase().includes(this.searchByday.toLowerCase())
              ) {
                return true;
              } else {
                false;
              }
            } else {
              return false;
            }
          case "assigned":
            if (alert.status === "ASIGNADA") {
              if (
                this.searchByday === "" ||
                date.toLowerCase().includes(this.searchByday.toLowerCase())
              ) {
                return true;
              } else {
                false;
              }
            } else {
              return false;
            }
        }
      });
    }
  },
  beforeMount() {
    this.fetchConfiguration();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
